export let NotifyMixin = {
    methods: {
        successNotify(options = {}) {
            this.$notify.success({
                title: options.title || "",
                message: options.message || "Successful change"
            });
        },
        errorNotify(options = {}) {
            this.$notify.error({
                title: options.title || "",
                message: options.message || "Unknown error"
            });
        }
    }
}

export let ActionMixin = {
    methods: {
        action(resource, action, id, data) {
            data = Object.assign(
                {
                    id,
                    action
                },
                data || {}
            );
            return resource.update(data).catch(err => {
                let message = err.toString();
                if (message == "[object Object]")
                    message = `${err.statusText}: ${err.bodyText.slice(
                        0,
                        100
                    )}...`;
                this.errorNotify({ message });
            });
        },
    }
}
